import React from "react";
import { Checkbox } from "antd";
import { Icon } from "Components";

interface Props {
  organizationSelected: boolean;
  setOrganizationSelected: (value: boolean) => void;
  organizationUsers: number
}

const OrganizationRecipients: React.FC<Props> = ({
  organizationSelected,
  setOrganizationSelected,
  organizationUsers
}) => {
  return (
    <div className="phishing-step3__organization">
      <div className="phishing-step3__label">
        Organization <span className="required">*</span>
      </div>

      <div className="phishing-step3__org-box">
        <Checkbox
          disabled={!organizationUsers}
          checked={organizationSelected}
          onChange={(e) => setOrganizationSelected(e.target.checked)}
        />

        <div className="phishing-step3__org-info">
          <div className="phishing-step3__org-title">
            <Icon type="recipientBuilding" /> Entire organization
          </div>

          <span className="phishing-step3__org-count">{organizationUsers} {`user${organizationUsers > 1 ? 's' : ''}`}</span>
        </div>
      </div>
    </div>
  );
};

export default OrganizationRecipients;